import * as React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import SettingsBanner from './settings-banner/SettingsBanner';
import SubcampaignPayoutsList from './SubcampaignPayoutsList';
import SubcampaignPayoutsHeader from './header/SubcampaignPayoutsHeader';

import {
  fetchPayoutsBySubcampaign,
  resetPayoutsBySubcampaign
} from 'modules/subcampaigns/reducers/subcampaignPayouts';


import { isOther } from 'utils/subcampaign';
import { isInfluencerSettingsPageIncomplete } from 'utils/organization';
import { getPaymentInfo } from 'utils/payouts';

import './subcampaign-payouts.scss';

import type { Campaign, OrganizationSettings, Payout, Subcampaign, VariablePayment } from 'types';

type OwnProps = {
  campaign: Campaign,
  subcampaign: Subcampaign
};

type StateProps = {
  payoutsBySubcampaign: Array<Payout>,
  isLoading: boolean,
  variablePayments: Array<VariablePayment>,
  variablePaymentsAmount: number,
  organizationSettings: OrganizationSettings
};

type DispatchProps = {
  dispatchFetchPayoutsBySubcampaign: (a: number) => void,
  dispatchResetPayoutsBySubcampaign: () => void
};

type Props = OwnProps & StateProps & DispatchProps;

class SubcampaignPayouts extends React.PureComponent<Props> {
  componentDidMount() {
    const { subcampaign, dispatchFetchPayoutsBySubcampaign } = this.props;

    dispatchFetchPayoutsBySubcampaign(subcampaign.id);
  }

  componentWillUnmount() {
    const { dispatchResetPayoutsBySubcampaign } = this.props;

    dispatchResetPayoutsBySubcampaign();
  }

  render(): React.ReactNode {
    const {
      organizationSettings,
      payoutsBySubcampaign,
      campaign,
      subcampaign,
      variablePayments,
      variablePaymentsAmount,
      isLoading
    } = this.props;
    const otherArrangement = isOther(subcampaign);
    const paymentInfo = getPaymentInfo(subcampaign, otherArrangement, variablePayments);
    const settingsPageInComplete = isInfluencerSettingsPageIncomplete(organizationSettings);

    return (
      <section
        className="subcampaign-payouts"
        data-qa="subcampaign-payouts"
      >
        <SubcampaignPayoutsHeader
          campaign={campaign}
          subcampaign={subcampaign}
          hasPayouts={!isEmpty(payoutsBySubcampaign)}
          isLoading={isLoading}
          variablePayments={variablePayments}
          variablePaymentsAmount={variablePaymentsAmount}
        />
        {
          payoutsBySubcampaign.length > 0 && (
            <SubcampaignPayoutsList
              paymentInfo={paymentInfo}
              payouts={payoutsBySubcampaign}
              campaign={campaign}
              subcampaign={subcampaign}
              variablePaymentsAmount={variablePaymentsAmount}
            />
          )
        }
        {
          settingsPageInComplete && (
            <React.Fragment>
              <div className="subcampaign-payouts__overlay" />
              <div className="subcampaign-payouts__banner">
                <SettingsBanner
                  organizationId={organizationSettings.id}
                />
              </div>
            </React.Fragment>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = ({ organizationSettings, subcampaignPayouts, subcampaignVariablePayments }): StateProps => ({
  payoutsBySubcampaign: subcampaignPayouts.payouts,
  isLoading: subcampaignPayouts.isLoading || subcampaignVariablePayments.isLoading,
  variablePayments: subcampaignVariablePayments.variablePayments.items,
  variablePaymentsAmount: subcampaignVariablePayments.variablePayments.totalAmount || 0,
  organizationSettings: organizationSettings.organization
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchPayoutsBySubcampaign: (subcampaignId: number): void => {
    dispatch(fetchPayoutsBySubcampaign(subcampaignId));
  },

  dispatchResetPayoutsBySubcampaign: (): void => {
    dispatch(resetPayoutsBySubcampaign());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SubcampaignPayouts);
